"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.BearerChallengePolicy = void 0;
const constants_1 = require("../../common/constants");
class BearerChallengePolicy {
    constructor(getTokenForChallenge) {
        this.getTokenForChallenge = getTokenForChallenge;
        this.name = "BearerChallengePolicy";
        this.challengeRetryHeader = "x-atk-challenge-retry";
    }
    async sendRequest(request, next) {
        const initial = await next(request);
        // Only attempt a single retry on auth challenges
        if (initial.status === 401 && !request.headers.get(this.challengeRetryHeader)) {
            const header = initial.headers.get("WWW-Authenticate") || initial.headers.get("www-authenticate");
            if (header) {
                request.headers.set(this.challengeRetryHeader, "1");
                const token = await this.getTokenForChallenge({
                    wwwAuthenticate: header,
                    scopes: constants_1.AzureScopes,
                });
                if (token) {
                    request.headers.set("Authorization", `Bearer ${token}`);
                    return await next(request);
                }
            }
        }
        return initial;
    }
}
exports.BearerChallengePolicy = BearerChallengePolicy;
//# sourceMappingURL=pipelinePolicy.js.map